// Centred grey divider marking a resolution (docs/06-ux-rules.md
// "SystemNote style": "ResolvedMarker shares the same typographic
// treatment: grey line, 'Resolved by' capitalised, date de-emphasised";
// P5 D2).
import Checkmark from 'components/Icons/Checkmark'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { formatShortDateTime } from 'utilities/dateFormatters'

const t = buildTranslate('feedback_inbox.thread')

export interface ResolvedMarkerProps {
  name: string
  at: string
}

const ResolvedMarker = ({ name, at }: ResolvedMarkerProps) => {
  const [css] = useStyletron()

  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        padding: '4px 0',
      })}
    >
      <span
        aria-hidden="true"
        className={css({ display: 'inline-flex', transform: 'scale(0.8)' })}
      >
        <Checkmark />
      </span>
      <span className={css({ fontSize: '13px', color: palette.grey70 })}>
        {t('resolved_marker_label')} {name}
        <span
          className={css({
            color: palette.grey50,
            marginLeft: '6px',
            whiteSpace: 'nowrap',
          })}
        >
          · {formatShortDateTime(at)}
        </span>
      </span>
    </div>
  )
}

export default ResolvedMarker
